import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/attention-icon.svg'


const _hoisted_1 = {
  key: 0,
  class: "b-complete-booking__wrapper align-center"
}
const _hoisted_2 = { class: "b-complete-booking__content flex middle-xs center-xs" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  width: "48",
  height: "48",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "regular black" }
const _hoisted_5 = { class: "border-radius black regular" }
const _hoisted_6 = { class: "align-left" }
const _hoisted_7 = { class: "align-right" }
const _hoisted_8 = { class: "black regular" }
const _hoisted_9 = { class: "b-complete-booking__btns" }
const _hoisted_10 = { class: "regular black" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-xs-12 align-right" }
const _hoisted_13 = {
  key: 0,
  class: "regular red"
}
const _hoisted_14 = {
  key: 0,
  class: "b-unpaid-trips flex between-xs middle-xs"
}
const _hoisted_15 = { class: "white medium" }

import { computed, ComputedRef } from 'vue';
  import { format, parse } from 'date-fns';
  import { useStore } from 'vuex';
  import { RouterLink, useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { Order } from 'types';
  import ModalComponent from './ModalComponent.vue';
  import ButtonComponent from './ButtonComponent.vue';
  import SpinnerComponent from './SpinnerComponent.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CompletePaymentComponent',
  setup(__props) {

  const { t } = useI18n();
  const route = useRoute();
  const store = useStore();

  const pendingOrder: ComputedRef<Order.PendingOrder> = computed(
    () => store.state.booking.pendingOrder,
  );

  const dates = computed(() => {
    const mask = 'DD MMM';
    return pendingOrder.value.order
      ? `${format(
          parse(pendingOrder.value.order.order_data.booking_details.checkin),
          mask,
        )} - ${format(
          parse(pendingOrder.value.order.order_data.booking_details.checkout),
          mask,
        )}`
      : '';
  });

  const hotelAddress = computed(() => {
    if (
      pendingOrder.value.order &&
      pendingOrder.value.order.order_data.property
    ) {
      const property = pendingOrder.value.order.order_data.property;
      if (property.country === 'US') {
        const statePlusZip = property.state ? property.state : '';
        const arr = [
          property.address,
          property.city,
          statePlusZip,
          property.country,
        ].filter(it => it);
        return arr && arr.length > 0
          ? arr.reduce((acc, s) => acc + ', ' + s)
          : '';
      } else {
        const arr = [property.address, property.city, property.country].filter(
          it => it,
        );
        return arr && arr.length > 0
          ? arr.reduce((acc, s) => acc + ', ' + s)
          : '';
      }
    } else return '';
  });

  const guestFullame = computed(() => {
    if (
      pendingOrder.value.order &&
      pendingOrder.value.order.order_data.booking_details.guest
    ) {
      return [
        pendingOrder.value.order.order_data.booking_details.guest.first_name,
        pendingOrder.value.order.order_data.booking_details.guest.last_name,
      ].join(' ');
    } else return '';
  });

  const showModal = computed(() => {
    return (
      pendingOrder.value.order &&
      pendingOrder.value.show &&
      pendingOrder.value.source === Order.PendingOrderSource.Booking
    );
  });

  const showSnackbar = computed(() => {
    return (
      pendingOrder.value.order &&
      !['profile-trips', 'order'].includes(route.name as string) &&
      pendingOrder.value.source === Order.PendingOrderSource.User
    );
  });

  function cancelPendingOrder() {
    store.commit('booking/cancelPendingOrder');
  }

  function showDeferredOrderCancellationStates(show: boolean) {
    store.commit('booking/showDeferredOrderCancellationStates', {
      show,
    });
  }

  function continuePayment() {
    store.dispatch('booking/initDecta3ds', {
      thrredUrl: this.pendingOrder.order.thrred_url,
      orderId: this.pendingOrder.order.order_id,
      source: Order.PendingOrderSource.DeferredOrder,
    });
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ModalComponent, {
      class: "b-complete-booking",
      state: _unref(showModal),
      type: "prompt",
      "modal-name": "complete-booking"
    }, {
      default: _withCtx(() => [
        (_unref(pendingOrder).order)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, [
                  _hoisted_3,
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('completeBooking.title')), 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", null, _toDisplayString(_unref(dates)), 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(pendingOrder).order.order_data.property.name), 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(hotelAddress)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", null, _toDisplayString(_unref(guestFullame)), 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(pendingOrder).order.order_data.booking_details.room.type), 1)
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('completeBooking.callToAction')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(ButtonComponent, {
                  class: "no-shadow",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showDeferredOrderCancellationStates(true)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('completeBooking.cancelBtn')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(ButtonComponent, {
                  class: "primary no-shadow",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (continuePayment()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('completeBooking.completeBtn')), 1)
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["state"]),
    _createVNode(ModalComponent, {
      class: "b-cancel-order",
      state: _unref(pendingOrder).cancellation.show,
      type: "prompt",
      onModalClose: _cache[3] || (_cache[3] = ($event: any) => (showDeferredOrderCancellationStates(false))),
      "modal-name": "cancel-order"
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('completeBooking.cancellation.title')), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(ButtonComponent, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (cancelPendingOrder())),
              class: "white no-shadow"
            }, {
              default: _withCtx(() => [
                (_unref(pendingOrder).cancellation.loading)
                  ? (_openBlock(), _createBlock(SpinnerComponent, {
                      key: 0,
                      color: "white"
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_unref(t)('completeBooking.cancellation.btn')), 1)
                    ], 64))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('completeBooking.cancellation.content')), 1),
        (_unref(pendingOrder).cancellation.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(pendingOrder).cancellation.error), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["state"]),
    (_unref(showSnackbar))
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)('completeBooking.unpaidTrips.text')), 1),
          _createVNode(_unref(RouterLink), { to: "/profile/trips" }, {
            default: _withCtx(() => [
              _createVNode(ButtonComponent, { class: "white" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('completeBooking.unpaidTrips.btn')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})